const common = {
  'site.name': '91高清视频',
  'site.slogan': '高清画质 · 流畅观影 · 精彩无限',
  'nav.home': '首页',
  'nav.category': '分类',
  'nav.about': '关于我们',
  'nav.articles': '影评资讯',
  'footer.rights': '© 2026 91高清视频 版权所有',
  'footer.privacy': '隐私政策',
  'footer.terms': '服务条款',
  'footer.contact': '联系我们',
  'video.duration': '时长',
  'video.quality': '画质',
  'video.views': '次播放',
  'video.rating': '评分',
  'video.watch': '立即观看',
  'video.related': '相关推荐',
  'video.tags': '标签',
  'category.all': '全部',
  'breadcrumb.home': '首页',
  'hero.title': '畅享高清视界',
  'hero.subtitle': '海量高清影片，极致观影体验',
  'hero.cta': '开始探索',
  'featured.title': '精选推荐',
  'latest.title': '最新上架',
  'categories.title': '影片分类',
  'articles.title': '影评资讯',
  'about.title': '关于我们',
  'about.brand': '品牌介绍',
  'about.reputation': '品牌口碑',
  'about.contact': '联系方式',
  'scroll.top': '回到顶部',
};

export default common;